"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetCheckedChannels = exports.toggleChannelChecked = exports.RESET_CHECKED_CHANNELS = exports.TOGGLE_CHANNEL_CHECKLED = void 0;
var TOGGLE_CHANNEL_CHECKLED = 'zola/userAwareness/TOGGLE_CHANNEL_CHECKLED';
exports.TOGGLE_CHANNEL_CHECKLED = TOGGLE_CHANNEL_CHECKLED;
var RESET_CHECKED_CHANNELS = 'zola/userAwareness/RESET_CHECKED_CHANNELS';
exports.RESET_CHECKED_CHANNELS = RESET_CHECKED_CHANNELS;

// Actions
var toggleChannelChecked = function toggleChannelChecked(channel, isChecked) {
  return {
    type: TOGGLE_CHANNEL_CHECKLED,
    payload: {
      channel: channel,
      isChecked: isChecked
    }
  };
};

exports.toggleChannelChecked = toggleChannelChecked;

var resetCheckedChannels = function resetCheckedChannels() {
  return {
    type: RESET_CHECKED_CHANNELS
  };
};

exports.resetCheckedChannels = resetCheckedChannels;